/* src/app/private/configrations/domain-authentication/domain-authentication.component.scss */
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
/*# sourceMappingURL=domain-authentication.component.css.map */
